import { useApp } from "@/context/AppContext";
import { LANGS } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "@phosphor-icons/react";

export default function LanguageSwitcher() {
  const { lang, setLang } = useApp();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher"
        aria-label="Change language"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-full border border-gray-200 hover:border-gray-400 text-sm font-medium text-gray-700 transition-colors"
      >
        <Globe size={16} weight="regular" />
        <span className="font-mono-code text-xs uppercase tracking-wider">
          {current.code}
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px] bg-white">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`flex items-center justify-between cursor-pointer ${
              l.code === lang ? "bg-[#F3F1ED] font-medium" : ""
            }`}
          >
            <span>{l.label}</span>
            <span className="font-mono-code text-[10px] uppercase text-gray-500">
              {l.code}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
